import { getOpeningHours } from "../../functions/OperatingHours";

// Set opening and closing time using 12-hours format

interface Holiday {
    date: string;
    name: string;
}

type IsBankHoliday = (date: Date) => boolean;

const openingHours = getOpeningHours();

const bankHolidays = (): IsBankHoliday => {
    const currentYear: number = new Date().getFullYear();
    const numYears: number = 20;

    const generateHolidays = (): Holiday[] => {
        const holidays: Holiday[] = [];

        for (let i: number = 0; i < numYears; i++) {
            const year: number = currentYear + i;

            // Set bank holidays manually if necessary
            holidays.push(
                { date: `${year}-01-01`, name: "New Year's Day" },
                { date: getEasterDate(year, -2), name: "Good Friday" },
                { date: getEasterDate(year, 1), name: "Easter Monday" },
                { date: getFirstMonday(year, 5), name: "Early May Bank Holiday" },
                { date: getLastMonday(year, 5), name: "Spring Bank Holiday" },
                { date: getLastMonday(year, 8), name: "Summer Bank Holiday" },
                { date: `${year}-12-25`, name: "Christmas Day" },
                { date: `${year}-12-26`, name: "Boxing Day" }
            );
        }

        return holidays;
    };

    const getEasterDate = (year: number, offset: number): string => {
        // Calculation for Easter date based on Gauss's algorithm
        const a: number = year % 19;
        const b: number = Math.floor(year / 100);
        const c: number = year % 100;
        const d: number = Math.floor(b / 4);
        const e: number = b % 4;
        const f: number = Math.floor((b + 8) / 25);
        const g: number = Math.floor((b - f + 1) / 3);
        const h: number = (19 * a + b - d - g + 15) % 30;
        const i: number = Math.floor(c / 4);
        const k: number = c % 4;
        const L: number = (32 + 2 * e + 2 * i - h - k) % 7;
        const m: number = Math.floor((a + 11 * h + 22 * L) / 451);
        const month: number = Math.floor((h + L - 7 * m + 114) / 31);
        const day: number = ((h + L - 7 * m + 114) % 31) + 1;

        const date: Date = new Date(year, month - 1, day);
        date.setDate(date.getDate() + offset); // Apply offset for Good Friday and Easter Monday

        return date.toISOString().slice(0, 10);
    };

    const getFirstMonday = (year: number, month: number): string => {
        const date: Date = new Date(year, month - 1, 1);
        const day: number = date.getDay();
        const offset: number = day === 0 ? 1 : 8 - day;

        date.setDate(offset);
        return date.toISOString().slice(0, 10);
    };

    const getLastMonday = (year: number, month: number): string => {
        const date: Date = new Date(year, month, 0);
        const day: number = date.getDay();
        const offset: number = day === 1 ? -3 : 7 - (day - 1);

        date.setDate(date.getDate() + offset);
        return date.toISOString().slice(0, 10);
    };

    const holidays: Holiday[] = generateHolidays();

    // Function to check if a specific date is a bank holiday
    const isBankHoliday: IsBankHoliday = (date: Date): boolean => {
        const formattedDate: string = date.toISOString().slice(0, 10);
        return holidays.some(holiday => holiday.date === formattedDate);
    };

    return isBankHoliday;
}

export { openingHours, bankHolidays };